//import $ from 'jquery';
import Param from '../../helpers/Param';
import AuthHeader from '../../helpers/AuthHeader';
import BuildQS from '../../helpers/BuildQS';
import config from '../../config/config';
import objectToFormData from 'object-to-formdata';
import {searchService} from './search';

export const milestonesService = {
    getMilestones,
    getEntityMilestones,
    getMilestoneTypes,
    getMilestonesByType,
    addMilestone,
    editMilestone,
    deleteMilestone,
    linkMilestone,
    unlinkMilestone,
    bulkAddMilestones,
    bulkDeleteMilestones, 
    updateMilestonesByType,
    deleteMilestonesByType
};

function getMilestones(campaign){
    return config.live ? getMilestonesLive(campaign) : getMilestonesStatic();
}

function getMilestonesLive(campaign) {
    let headers = AuthHeader(),
        baseUrl = `${config.apis.milestones}/milestones/ei/ei_promotion/${campaign}?include_linked=true`;
    return fetch(baseUrl, {
        method: 'GET',
        headers
    })
    .then(res=>{   
        return res.json()
    })
}

function getMilestonesStatic(params) {
    let baseUrl = `${config.apis.sales}/api/static/milestones.json`;
    return fetch(baseUrl, {
        method: 'GET'
    })
    .then(res=>{   
        return res.json()
    })
}

function getEntityMilestones(entity, ids, user){
    return config.live ? getEntityMilestonesLive(entity, ids, user) : getEntityMilestonesStatic();
}

function getEntityMilestonesLive(entity, ids, user) {
    
    entity = entity.replace(/.$/, '');
    if(ids instanceof Array) {
        ids = ids.join(',')
    }
    
    let headers = AuthHeader({'Content-Type': 'application/json'}),
        baseUrl = `${config.apis.milestones}/milestones/milestones_for_entities`,
        qs = {
            entity_ids: ids,
            entity_type: entity,
            user_id: user.id,
            user_silo_codes: user.primary_silo_code
        };
        
    //baseUrl += '?' + Param(qs).replace(/%2C/g,',');
        
    return fetch(baseUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(qs)
    })
    .then(res=>{   
        return res.json()
    })
}

function getEntityMilestonesStatic(params) {
    let baseUrl = `${config.apis.sales}/api/static/milestones_for_entities.json`;
    return fetch(baseUrl, {
        method: 'GET'
    })
    .then(res=>{   
        return res.json()
    })
}

function getMilestoneTypes() {
    let headers = AuthHeader({'Content-Type': 'application/json'}),
        baseUrl = `${config.apis.milestones}/milestone_types`;
    return fetch(baseUrl, {
        method: 'GET',
        headers
    })
    .then(res=>{   
        return res.json()
    })
}

function addMilestone(data) {
    let headers = AuthHeader({'Content-Type': 'application/json'}),
        baseUrl = `${config.apis.milestones}/milestones`;
    return fetch(baseUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(data)
    })
    .then(res=>{   
        return res.json()
    })
    
}

function editMilestone(data, id) {
    let headers = AuthHeader({'Content-Type': 'application/json'}),
        baseUrl = `${config.apis.milestones}/milestones/${id}`;
    return fetch(baseUrl, {
        method: 'PUT',
        headers,
        body: JSON.stringify(data)
    })
    .then(res=>{   
        return res.json()
    })
}

function deleteMilestone(id) {
    let headers = AuthHeader({'Content-Type': 'application/json'}),
        baseUrl = `${config.apis.milestones}/milestones/${id}`;
    return fetch(baseUrl, {
        method: 'DELETE',
        headers,
    })
    .then(res=>{   
        return res.json()
    })
}

function linkMilestone(data) {
    let headers = AuthHeader(),
        baseUrl = `${config.apis.milestones}/milestone_entity_link`;
    return fetch(baseUrl, {
        method: 'POST',
        headers,
        body: objectToFormData(data)
    })
    .then(res=>{   
        return res.json()
    })
    
}

function unlinkMilestone(id) {
    let headers = AuthHeader(),
        baseUrl = `${config.apis.milestones}/milestone_entity_link/${id}`;
    return fetch(baseUrl, {
        method: 'DELETE',
        headers,
    })
    .then(res=>{   
        return res.json()
    })
    
}

function bulkAddMilestones(data) {
    let headers = AuthHeader({'Content-Type': 'application/json'}),
        baseUrl = `${config.apis.milestones}/milestones/batch`;
    return fetch(baseUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify(data)
    })
    .then(res=>{   
        return res.json()
    })
    
}


function getMilestonesByType(type, page, pageSize, currentUser, sorted, filtered){
    return config.live ? getMilestonesByTypeLive(type, page, pageSize, currentUser, sorted, filtered) : getMilestonesByTypeStatic();
}

function getMilestonesByTypeLive(type, page, pageSize, currentUser, sorted, filtered) {
    let headers = AuthHeader(),
        baseUrl = `${config.apis.milestones}/milestone/${type}`,
        qs = {
            user_id: currentUser.id,
            user_silo_codes: currentUser.primary_silo_code,
            page: Number(page)+1,
            per_page: pageSize
        };
		if(currentUser.client_admin)
			qs.admin = 'true';
        
        if(Array.isArray(sorted)){
            sorted = sorted[0];
            let orderField = sorted.id;
            if(orderField === 'owner') orderField = 'public';
            qs.order_by = orderField;
            qs.order_dir = sorted.desc ? 'desc':'asc';
        }
        if(Array.isArray(filtered)){
            for(let filter of filtered) {
                let value = filter.value;
                if(!value)
                    continue;
                
                if(filter.id == 'entity_type')
                    value = value.replace(/s$/, '');
                
                if(value instanceof Array) {
                    value = value.join(',');
                    if(!value)
                        continue;
                    qs[filter.id] = value;
                }
                else {
                    qs[filter.id] = value;    
                }
            }            
        }
            
    baseUrl += '?' + Param(qs).replace(/%2C/g,',');

    return fetch(baseUrl, {
        method: 'GET',
        headers
    })
    .then(res=>{   
        return res.json()
    })
}

function getMilestonesByTypeStatic(params) {
    let baseUrl = `${config.apis.sales}/api/static/milestones_by_type.json`;
    return fetch(baseUrl, {
        method: 'GET'
    })
    .then(res=>{   
        return res.json()
    })
}

function bulkDeleteMilestones(ids) {
    let headers = AuthHeader(),
        baseUrl = `${config.apis.milestones}/milestones/batch_destroy?ids=${ids.join(',')}`;
    return fetch(baseUrl, {
        method: 'DELETE',
        headers
    })
    .then(res=>{   
        return res.json()
    })
    
    
}

function updateMilestonesByType(type, currentUser, parameter) {
    let headers = AuthHeader(),
        baseUrl = `${config.apis.milestones}/milestones/batch_update`,
        qs = {
            type_id: type,
            user_id: currentUser.id,
            user_silo_codes: currentUser.primary_silo_code,
            ...parameter
        };
        
        if(currentUser.client_admin)
            qs.admin = 'true';
            
    baseUrl += '?' + Param(qs).replace(/%2C/g,',');

    return fetch(baseUrl, {
        method: 'POST',
        headers
    })
    .then(res=>{   
        return res.json()
    })
}


function deleteMilestonesByType(type, currentUser) {
    let headers = AuthHeader(),
        baseUrl = `${config.apis.milestones}/milestone/${type}`,
        qs = {
            user_id: currentUser.id,
            user_silo_codes: currentUser.primary_silo_code,
        };
        if(currentUser.client_admin)
            qs.admin = 'true';
            
    baseUrl += '?' + Param(qs).replace(/%2C/g,',');

    return fetch(baseUrl, {
        method: 'DELETE',
        headers
    })
    .then(res=>{   
        return res.json()
    })
}
